import axios from "axios";
import { baseUrl, baseURL, config, requestID } from "../../common/utils";

export const getServices = async () => {
  const data = {
    requestID: requestID(),
  };
  try {
    const response = await axios.post(
      `${baseURL}/services/getMySubmissions`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const assignStaffToService = async (payload) => {
  const data = {
    requestID: requestID(),...payload
  };
  try {
    const response = await axios.post(
      `${baseURL}/services/assignStaffToService`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const assignStaffToProject = async (payload) => {
  const data = {
    requestID: requestID(),...payload
  };
  try {
    const response = await axios.post(
      `${baseURL}/services/assignStaffToProject`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};




 

export const projectDelete = async (projectId: string): Promise<{ message: string; status:boolean; response: any[]}> => {

   try {
     const response = await axios.post(`${baseUrl()}projects/deleteProject`, {
        project_id: projectId,
        requestID: requestID(),
       }, config)

       console.log("Get all projects delete response:", response)

       // Check if the API call was successful
              return  response.data;

  } catch (error: any) {
    console.error("Error creating project:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to create project")
  }   
}

export const getAllServices = async () => {
  const data = {
    requestID: requestID(),
  };
  try {
    const response = await axios.post(
      `${baseURL}/services/getAllSubmissions`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getStaffAssignedRequest = async () => {
  const data = {
    requestID: requestID(),
  };
  try {
    const response = await axios.post(
      `${baseURL}/services/getAssignedServices`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const createServices = async (payload) => {
  const data = {
    requestID: requestID(),
    ...payload,
  };
  try {
    const response = await axios.post(
      `${baseURL}/services/submitService`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

